import { OperationOutcome } from "fhir/r4"

export type AuthResponse = {
  access_token: string
  expires_at: number
}
export type FetchAuthResponse = {
  access_token: string
  expires_in: number
}
const error: OperationOutcome = {
  resourceType: "OperationOutcome",
  issue: [
    {
      code: "processing",
      details: { text: "An unknown error has occurred" },
      diagnostics: "An unknown error has occurred",
      severity: "error",
    },
  ],
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFetchAuthResponse = (response: any): response is FetchAuthResponse => {
  return response && typeof response.access_token === "string" && typeof response.expires_in === "number"
}

export async function refreshToken(token: string): Promise<AuthResponse | OperationOutcome> {
  const response = await fetch(`/api/auth/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.ok) {
    const responseData = await response.json()
    if (isFetchAuthResponse(responseData)) {
      return {
        access_token: responseData.access_token,
        expires_at: Math.floor(new Date().getTime() / 1000) + responseData.expires_in,
      }
    }
    return responseData
  } else {
    return error
  }
}
